export const boys = [
    {title:"Goose", url:"dogs/boys/goose"},
    {title:"Maso", url:"dogs/boys/maso"},
];